import { render } from "./Misc.vue?vue&type=template&id=5a471e80&ts=true"
import script from "./Misc.vue?vue&type=script&lang=ts"
export * from "./Misc.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__